<template>
  <div class="popover">
    <TanninLevelDisplay
                        :label="title"
                        :ranges="range"
                        :value="val"
                        :mini="true"
    />
  </div>
</template>

<script>
import TanninLevelDisplay from './TanninLevelDisplay';

export default {
  props: ['range', 'val', 'title'],
  components: {
    TanninLevelDisplay,
  },
};
</script>

<style lang="scss" scoped>
  .popover{
    width: 15rem;
    background: #f1f1f1;
    border-radius: 5px;
    padding: .5rem;
    border: 1px solid #dddddd;
    position: relative;
    box-shadow: 1px 1px 7px rgba(0,0,0,0.3);
  }
</style>



// WEBPACK FOOTER //
// src/components/RangePopup.vue